import { useQueryClient } from '@tanstack/react-query';
import { useEffect, useRef } from 'react';

/**
 * Drops every cached query when the signed-in user changes or signs out: the next person on this browser
 * must never see the previous one's organization names, members or projects, not even for a moment.
 * Compares ids rather than relying on effect cleanup, which StrictMode also runs on the first mount and
 * which would throw away queries that are still in flight.
 */
export function useClearCacheOnUserChange(userId: string | null): void {
  const qc = useQueryClient();
  const previous = useRef<string | null>(userId);
  useEffect(() => {
    if (previous.current !== null && previous.current !== userId) qc.clear();
    previous.current = userId;
  }, [qc, userId]);
}
